import { exists, SystemCode, SystemCodeFromJSON } from '@/api'

export interface ConditionReserveExtendGroup {
  id: number
  limitCheckMethod: LimitCheckMethod
  numberOfLimit: number
  materialFormats: SystemCode[]
  revision: number
}

export const LimitCheckMethod = {
  All: '0',
  Own: '1'
} as const
export type LimitCheckMethod = typeof LimitCheckMethod[keyof typeof LimitCheckMethod]

export function ConditionReserveExtendGroupFromJSON(
  json: any
): ConditionReserveExtendGroup {
  return {
    id: exists(json, 'id') ? json.id : 0,
    limitCheckMethod: exists(json, 'limit_check_method')
      ? json.limit_check_method
      : LimitCheckMethod.All,
    numberOfLimit: exists(json, 'number_of_limit') ? json.number_of_limit : 0,
    materialFormats: exists(json, 'material_formats')
      ? json.material_formats.map(SystemCodeFromJSON)
      : [],
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
